export default __webpack_public_path__ + "static/media/Aneros.a06a9075.png";